export default __webpack_public_path__ + "static/media/regulatory--one-way-left--g1.b090ec6f.png";